/**
 * faq-custom.js
 *
 * Wires up the tab navigation for every .is-faq-section-custom section
 * on the page. Tabs switch visibility of sibling .faq panels.
 *
 * Load with:
 *   <script src="{{ 'faq-custom.js' | asset_url }}" defer></script>
 *
 * CWV notes
 *  – Deferred: zero render-blocking.
 *  – First panel is visible by default via CSS (.faq:first-of-type { display:flex })
 *    so there is no layout shift or flash of hidden content before JS runs.
 *  – Click handler only toggles classes; no DOM measurements, no forced reflow.
 *  – One DOMContentLoaded listener safely initialises every section instance.
 */

(function () {
  'use strict';

  /**
   * Initialise tab switching for a single FAQ section container.
   * @param {HTMLElement} section
   */
  function initFaqTabs(section) {
    var tabItems = Array.from(section.querySelectorAll('.tab__list'));
    var faqPanels = Array.from(section.querySelectorAll('.faq'));

    if (tabItems.length === 0 || faqPanels.length === 0) return;

    /* Build a map: contentId → faqPanel for O(1) lookup */
    var panelMap = {};
    faqPanels.forEach(function (panel) {
      var id = panel.dataset.contentId;
      if (id) panelMap[id] = panel;
    });

    function activateTab(clickedItem) {
      /* Update tab active state */
      tabItems.forEach(function (item) {
        item.classList.toggle('active', item === clickedItem);
      });

      /* Update panel visibility */
      var targetId = clickedItem.querySelector('.custom-tab').dataset.contentId;

      faqPanels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.dataset.contentId === targetId);
      });
    }

    /* Activate the first tab on init (aligns with CSS default) */
    activateTab(tabItems[0]);

    /* Bind clicks */
    tabItems.forEach(function (item) {
      item.addEventListener('click', function () {
        activateTab(item);
      });

      /* Keyboard: Enter / Space activate focused tab */
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activateTab(item);
        }
      });

      /* Make tabs keyboard-focusable */
      var tab = item.querySelector('.custom-tab');
      if (tab) tab.setAttribute('tabindex', '0');
    });
  }

  function init() {
    document
      .querySelectorAll('.is-faq-section-custom')
      .forEach(initFaqTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());